import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { DateLocaleService } from '../shared/services/date-locale.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  /** Mapping frontend languages to API formats */
  private languageMapping: { [key: string]: string } = {
    en: 'en_US',
    fr: 'fr_FR',
    it: 'it_IT',
  };

  constructor(
    private translate: TranslateService,
    private store: Store,
    private dateLocaleService: DateLocaleService
  ) {}

  // Set initial language on login or refresh
  setInitialLanguage(userLang?: string) {
    const savedLang = localStorage.getItem('lang') || userLang || 'en';
    localStorage.setItem('lang', savedLang);
    this.translate.use(savedLang);
    this.dateLocaleService.setLocale(savedLang);
  }

  // Set the language on login if the user has a lang
  setUserLanguage(userLang?: string) {
    const lang = userLang || localStorage.getItem('lang') || 'en'; // Default to 'en'
    this.translate.use(lang);
    localStorage.setItem('lang', lang);
    this.dateLocaleService.setLocale(lang);
  }

  // Change language and update API
  changeLanguage(lang: string) {
    localStorage.setItem('lang', lang);
    this.translate.use(lang);
    this.dateLocaleService.setLocale(lang);
  }

  // Get the current language
  getCurrentLanguage(): string {
    return localStorage.getItem('lang') || 'en';
  }

  // Convert API language (e.g., en_US) to frontend language (e.g., en)
  private getFrontendLang(apiLang: string): string {
    return (
      Object.keys(this.languageMapping).find((key) => this.languageMapping[key] === apiLang) || 'en'
    ); // Default to 'en' if not found
  }
}
